import './text-alert.css';

import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import { TextAlertProps } from './text-alert.types';

export default function TextAlert({ severity, children }: TextAlertProps) {
  return (
    <div className={`text-alert text-alert-${severity}`}>
      <div className="text-alert-accent" />
      <div className="text-alert-content">
        <Icon name={ICONS.INFO_OUTLINE} className="text-alert-icon" size={20} />
        <div>{children}</div>
      </div>
    </div>
  );
}
